import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';   
import LazyLoad from 'react-lazyload'; 
const OurHeavenlyPatron = () => { 
        useEffect(() => {
        document.title = 'Our Heavenly Patron -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  About Us  </li> 
     <li> Our Heavenly Patron </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1> Our Heavenly Patron  </h1>
         </div>
     </div>
     <div className="row">  
       <div className="clearfix">
          <LazyLoad> <img 
           src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/Patron.PNG" 
           className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 Patronmsgimg" 
           alt=""
         /></LazyLoad>
           <p> St. Peter was born at Bethsaida on the shore of the sea Galilee. He settled down at Capernaum, earned his living by fishing until Jesus called him to "become a fisher of men". His name was Simon, but our Lord, on first meeting him that he should be Cephas, the Aramaic equivalent of the Greek Word whose English Form is Peter (i.e. rock). He is Premier among the twelve disciples, a man of great holiness and meekness. It was he who, as the spokesman of the rest made sublime profession of faith, "You are the Messiah, the Son of the Living God". God filled him with true wisdom and knowledge. He preached the first public sermon at Pentecost. There are two books in the Holy Bible to his credit. He urges his readers to live as people belong to God. He says that "God doesn't want anyone to be destroyed, but wants all to turn from their sins". The passion of St.Peter took place in Rome during the reign of Nero. When he came to the cross he said, "I am not worthy to be put on cross like as my Lord was, therefore turn my cross and crucify me my head downward". St.Peter is a true model for all students seeking moral and intellectual attainments. May all the Peterians be rock-like as St.Peter was, in their convictions based on noble virtues, refined character and faith in Divine Power.</p>
       </div> 
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default OurHeavenlyPatron
